module.exports = __webpack_public_path__ + "img/8.a3be6e26.png";